import { render, staticRenderFns } from "./MasterFieldListHeader.vue?vue&type=template&id=4488ff0e&scoped=true&"
import script from "./MasterFieldListHeader.vue?vue&type=script&lang=ts&"
export * from "./MasterFieldListHeader.vue?vue&type=script&lang=ts&"
import style0 from "./MasterFieldListHeader.vue?vue&type=style&index=0&id=4488ff0e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4488ff0e",
  null
  
)

export default component.exports